import ApiService from "@Src/services/ApiService";
import { DASHBOARD_API_ROUTES } from "./Dashboard.api.constant";

export async function getUserTestDetails(){
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.DASHBOARD + '/' + DASHBOARD_API_ROUTES.TEST_DETAILS,
        method: 'get',
    })
}

export async function getUserTestPerformance(params:any){
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.DASHBOARD + '/' + DASHBOARD_API_ROUTES.USER_PERFORMANCE,
        method: 'get',
        params
    })
}